<template>
	<b-container class="show-document">
		<div class="doc-body">
			<div class="actions mb-2 mt-2 hidden-print">
				<div class="pull-left" style="display: flex; align-items: center; justify-content: space-between;">
					<b-button @click="goBackToFrom" variant="outline-dark" style="margin-right: 30px">
						<i class="fa fa-chevron-left" style="display: inline"></i>
						<span style="display: inline">{{ $t('back') }}</span>
					</b-button>
					<div style="display: flex; align-items: center; margin-right: 20px">
						Width: <b-input v-model="width" placeholder="W" type="number" style="width: 100px"/> mm.
					</div>
					<div style="display: flex; align-items: center">
						Height: <b-input v-model="height" placeholder="H" type="number" style="width: 100px"/> mm.
					</div>
				</div>
				<div class="pull-right">
					<b-button
						variant="outline-dark"
						class="mr-2"
						@click="print"
					>
						<i class="fa fa-print"></i>
						Печать Штрихкод
					</b-button>
					<div class="clearfix"></div>
				</div>
				<div class="clearfix"></div>
			</div>
			<b-modal
				:hide-header="true"
				v-model="confirmBackToBarcode"
				:no-close-on-esc="true"
				:no-close-on-backdrop="true"
				@ok=""
				size="md"
			>
				<h1> У вас нет доступа к этому товару!</h1>

				<div slot="modal-footer">
					<b-button
						variant="success"
						size="sm"
						class="float-right ml-2"
						@click="goBackToFrom"
					>
						OK
					</b-button>

				</div>


			</b-modal>
			<div>
				<div class="printElement text-center mt-4" v-for="n in count" :style="cssVars">
<!--					<p class="text-center info"><b>DUTY FREE</b></p>-->
<!--					<p style="font-size: 15px"><b>{{ShopName}}</b></p>-->
					<p class="text-center info"><b>{{item.barcode}}</b> <b v-if="item.priceUzs!==0" class="ml-2">€ - {{ item.priceUzs }} EUR</b><br/></p>
					<p class="text-center info"> {{ item.itemName }} <br/></p>
<!--					<p class="text-center prices"><b>Culoare: </b>{{item.color}}</p>-->
					<barcode :value="item.multiBarcode" :options="{ height: '50px',displayValue: false}" tag="svg"></barcode>
					<p style="font-size: 16px" class="barcode"><b>{{ item.multiBarcode }}</b></p>
<!--					<p class="text-center prices" style="font-size: 20px"><b>{{ itemPrice[0].priceUzs | currency({ symbol: userDepCurrencyName, fractionCount: 0, symbolPosition: 'back', thousandsSeparator: '.' }) }}</b></p>-->
				</div>
			</div>
		</div>
	</b-container>
</template>

<script>
import {mapState} from 'vuex'
import WhDocument from "../../../../services/wh-document.service";
import {TokenService} from "../../../../services/storage.service";
import PricesService from "../../../../services/prices.service";
import cssVars from 'css-vars-ponyfill';

export default {
	name: 'BarcodeGenerate',
	data() {
		return {
			item: {
				name: ''
			},
			name: '',
			count: 0,
			itemPrice: [
				{priceUzs: 0}
			],
			confirmBackToBarcode: false,
			noError: true,
			width: 70,
			height: 35
		}
	},
	computed: {
		...mapState(['userDepCurrencyName']),
		ShopName() {
			return JSON.parse(localStorage.getItem('TavarName'))
		},
		cssVars() {
			return {
				'--print-width': this.width + 'mm',
				'--print-height': this.height + 'mm'
			}
		}
	},

	methods: {
		async removePageSizeStyle() {
			var el = document.getElementById('stylePrintSizeId');
			if (el) {
				el.remove(); // Removes the div with the 'stylePrintSizeId' id
			}
		},
		async setPageSizeStyle(sizeValue) {
			await this.removePageSizeStyle();  // avval eski style ni o'chir

			const css = `@page { size: ${sizeValue} !important; margin: 0mm !important; }`;
			const head = document.head || document.getElementsByTagName('head')[0];
			const style = document.createElement('style');
			style.type = 'text/css';
			style.media = 'print';
			style.id = 'stylePrintSizeId';
			style.appendChild(document.createTextNode(css));
			head.appendChild(style);
		},
		async get() {
			let barcode = this.$route.params.id,
				itemId = this.$route.params.itemId,
				depId = this.$route.params.depId;
			this.count = parseInt(this.$route.params.count);
			let link = '?barcode=' + barcode + '&itemId=' + itemId;
			if (depId != 'null')
				link+=`&depId=${depId}`
			await PricesService.getItemByPrice(link).then(response => {
				if (response) {
					this.item = response.data
				} else {
					this.noError = false;
					// this.confirmBackToBarcode = true;
				}
			}).catch(error => {
				// this.confirmBackToBarcode = true;
			})
		},
		goBackToFrom() {
			this.$router.back();
		},
		async print() {
			// var printContents = document.getElementById('printElement').innerHTML;
			// var originalContents = document.body.innerHTML;
			//
			// document.body.innerHTML = printContents;
			await this.removePageSizeStyle();
			// ✅ landscape EMAS, to'g'ridan-to'g'ri mm
			await this.setPageSizeStyle(`${this.width}mm ${this.height}mm`);

			// ✅ Kichik delay — style inject bo'lishini kutish
			await new Promise(resolve => setTimeout(resolve, 300));
			window.print();
			//
			// document.body.innerHTML = originalContents;
			//
			// var printContents = document.getElementById('printElement').innerHTML;
			// var originalContents = document.body.innerHTML;
			// document.body.innerHTML = printContents;
			// window.print();
			// document.body.innerHTML = originalContents;
		}
	},
	async created() {
		await this.get()
	},
	beforeRouteEnter(to, from, next) {
		let current = this
		if (from.path === '/warehouse-management/goods') {
			next(vm => {
				vm.prevRoute = from
			})
		} else {
			next('/warehouse-management/goods');
		}
		next(vm => {
			vm.prevRoute = from
		})


	},

}
</script>

<style scoped>
body {
	background-color: white !important;
}

@page {
	margin: 0 !important;
}

@media print {
	@page { margin: 0; }
	html, body {
		margin: 0 !important;
		padding: 0 !important;
	}

	.hidden-print {
		display: none !important;
	}

	/* Bootstrap container ni o'ldirish */
	.container, .show-document, .doc-body {
		max-width: none !important;
		width: 100% !important;
		padding: 0 !important;
		margin: 0 !important;
	}

	.printElement {
		display: flex !important;
		flex-direction: column !important;
		align-items: center !important;
		justify-content: center !important;

		width: var(--print-width) !important;
		height: var(--print-height) !important;

		margin: 0 !important;
		padding: 2mm !important;
		box-sizing: border-box !important;

		page-break-after: always !important;
		overflow: hidden !important;
		color: #000 !important;
	}

	/* Barcha p teglar to'liq kenglik */
	.printElement p {
		width: 100% !important;
		margin: 0 !important;
		padding: 0 !important;
		font-family: "Arial Black", Gadget, sans-serif !important;
		text-align: center !important;
		color: #000 !important;
		font-weight: bold !important;
	}

	.info {
		font-size: 11px !important;
		line-height: 1.2 !important;
	}

	/* SVG barcode to'liq kenglik */
	.printElement svg {
		width: 90% !important;       /* ← 65mm o'rniga % */
		height: auto !important;
		max-height: 40% !important;  /* sahifaning 40% ini egallaydi */
	}

	/* Barcode raqam matni */
	.barcode {
		font-size: 14px !important;  /* ← 80px juda katta edi! */
		font-weight: bold !important;
		margin-top: 1mm !important;
	}

	.card { box-shadow: none !important; }
}


p {
	margin-bottom: 0px;
	font-size: 14px;
}

.printElement svg {
	width: 65mm;
	height: 20mm;
}


</style>
